/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/id';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Akses editor HTML yang apik"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Pemeriksa Aksesabilitas"
  },
  "action_to_take_b626a99a": {
    "message": "Tindakan untuk dilakukan:"
  },
  "add_8523c19b": {
    "message": "Tambah"
  },
  "add_a_caption_2a915239": {
    "message": "Tambah caption"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Tambah teks alternatif untuk gambar"
  },
  "add_another_f4e50d57": {
    "message": "Tambah lainnya"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Tambah CC/Subtitle"
  },
  "add_image_60b2de07": {
    "message": "Tambah Gambar"
  },
  "add_one_9e34a6f8": {
    "message": "Tambah satu!"
  },
  "additional_considerations_f3801683": {
    "message": "Pertimbangan tambahan"
  },
  "address_applied_64269b0b": {
    "message": "Alamat diterapkan"
  },
  "address_removed_fcb496e0": {
    "message": "Alamat dihapus"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Tautan berdekatan dengan URL yang sama harus berupa tautan tunggal."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Selaraskan"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Tugas dan Daftar"
  },
  "all_4321c3a1": {
    "message": "Semua"
  },
  "all_apps_a50dea49": {
    "message": "Semua App"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Izinkan unduhan media"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Izinkan unduhan transkrip"
  },
  "alpha_15d59033": {
    "message": "Alf:"
  },
  "alphabetical_55b5b4e0": {
    "message": "Menurut Abjad"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Teks atribut alternatif tidak boleh memuat lebih dari 120 karakter."
  },
  "alt_text_611fb322": {
    "message": "Teks Alternatif"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Coproduct)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Kesalahan terjadi saat membaca file"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Kesalahan terjadi saat membuat permintaan jaringan"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Terjadi kesalahan saat mengunggah media Anda."
  },
  "and_7fcc2911": {
    "message": "Dan"
  },
  "angle_c5b4ec50": {
    "message": "Angle"
  },
  "announcement_fb4cb645": {
    "message": "Pengumuman"
  },
  "announcement_list_da155734": {
    "message": "Daftar Pengumuman"
  },
  "announcements_a4b8ed4a": {
    "message": "Pengumuman"
  },
  "apply_781a2546": {
    "message": "Terapkan"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Terapkan perubahan ke semua instans dari Ikon Icon Maker ini di Kursus"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Mendekati Batas"
  },
  "approximately_e7965800": {
    "message": "Kira-Kira"
  },
  "apps_54d24a47": {
    "message": "App"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Anda yakin mau membatalkan? Perubahan yang Anda buat mungkin tidak tersimpan."
  },
  "arrows_464a3e54": {
    "message": "Panah"
  },
  "art_icon_8e1daad": {
    "message": "Ikon Seni"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Rasio aspek akan dipertahankan"
  },
  "assignment_976578a8": {
    "message": "Tugas"
  },
  "assignments_1e02582c": {
    "message": "Tugas"
  },
  "asterisk_82255584": {
    "message": "Asterisk"
  },
  "attributes_963ba262": {
    "message": "Atribut"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Rekaman audio dan video tidak didukung; silakan gunakan browser yang lain."
  },
  "audio_options_feb58e2c": {
    "message": "Opsi Audio"
  },
  "audio_options_tray_33a90711": {
    "message": "Tray Opsi Audio"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Pemutar audio untuk { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Konten yang otomatis disimpan sudah ada. Apakah Anda ingin memuat konten yang disimpan otomatis sebagai gantinya?"
  },
  "available_folders_694d0436": {
    "message": "Folder tersedia"
  },
  "background_1bc88842": {
    "message": "Latar Belakang"
  },
  "backslash_b2d5442d": {
    "message": "Backslash"
  },
  "bar_ec63ed6": {
    "message": "Bar"
  },
  "basic_554cdc0a": {
    "message": "Dasar"
  },
  "because_501841b": {
    "message": "Karena"
  },
  "below_81d4dceb": {
    "message": "Di Bawah"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Lingkaran Besar"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Koefisien Suku Dua"
  },
  "black_4cb01371": {
    "message": "Kulit Hitam"
  },
  "blue_daf8fea9": {
    "message": "Biru"
  },
  "bold_applied_42d547b7": {
    "message": "Cetak tebal diterapkan"
  },
  "bold_removed_da474a5c": {
    "message": "Cetak tebal dihapus"
  },
  "border_5b08b06d": {
    "message": "Batas"
  },
  "bottom_15a2a9be": {
    "message": "Dasar"
  },
  "bottom_third_5f5fec1d": {
    "message": "Ketiga Dari Bawah"
  },
  "bowtie_5f9629e4": {
    "message": "Dasi Kupu-Kupu"
  },
  "brick_f2656265": {
    "message": "Batu Bata"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Batal"
  },
  "cap_product_3a5265a6": {
    "message": "Produk Topi"
  },
  "caption_manager_aae0906f": {
    "message": "Manajer Caption"
  },
  "center_align_e68d9997": {
    "message": "Tengahkan"
  },
  "centered_dot_64d5e378": {
    "message": "Titik Ditengahkan"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Titik Horizontal Ditengahkan"
  },
  "change_alt_text_92654906": {
    "message": "Ubah teks alternatif"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Ubah tag heading ke paragraf"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Ubah hanya level dari heading ini"
  },
  "change_text_color_1aecb912": {
    "message": "Ubah warna teks"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Perubahan akan diterapkan setelah Anda menyimpan halaman ini."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Perubahan yang Anda buat mungkin tidak tersimpan."
  },
  "characters_9d897d1c": {
    "message": "Karakter"
  },
  "characters_no_spaces_485e5367": {
    "message": "Karakter (tanpa spasi)"
  },
  "check_accessibility_3c78211c": {
    "message": "Periksa Aksesabilitas"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Memeriksa masalah aksesabilitas"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Pilih file caption"
  },
  "choose_usage_rights_33683854": {
    "message": "Pilih hak penggunaan..."
  },
  "circle_484abe63": {
    "message": "Lingkaran"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "lingkari daftar yang belum diurutkan"
  },
  "clear_2084585f": {
    "message": "Kosongkan"
  },
  "clear_image_3213fe62": {
    "message": "Kosongkan gambar"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Klik atau shift-klik untuk editor html."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Klik untuk menanamkan { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Klik untuk menyembunyikan detail"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Klik untuk memasukkan tautan ke dalam editor."
  },
  "click_to_show_preview_faa27051": {
    "message": "Klik untuk menampilkan pratinjau"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Tutup menu atau dialog. Juga mengembalikan Anda ke area editor"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Tutup Pemeriksa Aksesabilitas"
  },
  "close_d634289d": {
    "message": "Tutup"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Tutup Modal Pintasan Keyboard"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "File closed caption harus lebih kecil dari { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Closed Caption/Subtitle"
  },
  "clubs_suit_c1ffedff": {
    "message": "Club (Suit)"
  },
  "collab_575ac7bc": {
    "message": "Collab"
  },
  "collaborations_5c56c15f": {
    "message": "Kolaborasi"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Tutup untuk menyembunyikan { types }"
  },
  "color_a363e1b0": {
    "message": "Warna"
  },
  "color_contrast_4c418add": {
    "message": "Rasio Kontras"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Rasio Kontras Warna"
  },
  "color_picker_6b359edf": {
    "message": "Pemilih Warna"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Pemilih Warna ({ colorName } dipilih)"
  },
  "color_popup_af39810f": {
    "message": "Popup warna"
  },
  "column_e1ae5c64": {
    "message": "Kolom"
  },
  "column_group_1c062368": {
    "message": "Grup kolom"
  },
  "complex_numbers_a543d004": {
    "message": "Bilangan Kompleks"
  },
  "computer_1d7dfa6f": {
    "message": "Komputer"
  },
  "congruent_5a244acd": {
    "message": "Kongruen"
  },
  "contains_311f37b7": {
    "message": "Memuat"
  },
  "content_1440204b": {
    "message": "Konten"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Konten di dalam editor akan berubah. Tekan Batal untuk mempertahankan konten orisinal."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Konten sedang diunggah, jika Anda melanjutkan, ini tidak akan tertanam dengan benar."
  },
  "content_subtype_5ce35e88": {
    "message": "Subtipe Jenis"
  },
  "content_type_2cf90d95": {
    "message": "Jenis Konten"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Lanjutkan ke konten YouTube"
  },
  "coproduct_e7838082": {
    "message": "Produk bersama"
  },
  "copyright_holder_66ee111": {
    "message": "Pemegang Hak Cipta:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Tidak bisa memasukkan konten: Item \"{ itemType }\" saat ini tidak didukung di Canvas."
  },
  "count_40eced3b": {
    "message": "Jumlah"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 kata}\n    one {1 kata}\n  other {# kata}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# item dimuat}\n  other {# item dimuat}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Dokumen Kursus"
  },
  "course_files_62deb8f8": {
    "message": "File Kursus"
  },
  "course_files_a31f97fc": {
    "message": "File kursus"
  },
  "course_images_f8511d04": {
    "message": "Gambar Kursus"
  },
  "course_link_b369426": {
    "message": "Tautan Kursus"
  },
  "course_links_b56959b9": {
    "message": "Tautan Kursus"
  },
  "course_media_ec759ad": {
    "message": "Media Kursus"
  },
  "course_navigation_dd035109": {
    "message": "Navigasi Kursus"
  },
  "create_icon_110d6463": {
    "message": "Buat Ikon"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Buat Ikon Pembuat Ikon"
  },
  "creative_commons_license_725584ae": {
    "message": "Lisensi Creative Commons:"
  },
  "crop_image_41bf940c": {
    "message": "Pangkas gambar"
  },
  "crop_image_807ebb08": {
    "message": "Pangkas Gambar"
  },
  "cup_product_14174434": {
    "message": "Produk Cangkir"
  },
  "current_image_f16c249c": {
    "message": "Gambar Saat Ini"
  },
  "current_link_945a47ee": {
    "message": "Tautan Saat Ini"
  },
  "current_volume_level_c55ab825": {
    "message": "Level Volume Saat Ini"
  },
  "custom_6979cd81": {
    "message": "Khusus"
  },
  "cyan_c1d5f68a": {
    "message": "Sian"
  },
  "dagger_57e0f4e5": {
    "message": "Belati"
  },
  "date_added_ed5ad465": {
    "message": "Tanggal Ditambahkan"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Ikon Dekoratif"
  },
  "decorative_image_fde98579": {
    "message": "Gambar dekoratif"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Dekoratif { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Kurangi Indent"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Kurangi Area Rich Content"
  },
  "deep_purple_bb3e2907": {
    "message": "Ungu Gelap"
  },
  "default_9db103d": {
    "message": "Default"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "daftar tidak diurutkan dengan bullet default"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "daftar tidak diurutkan numerik default"
  },
  "definite_integral_fe7ffed1": {
    "message": "Integral Definit"
  },
  "degree_symbol_4a823d5f": {
    "message": "Simbol Derajat"
  },
  "delimiters_4db4840d": {
    "message": "Delimiter"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Jelaskan ikon)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Jelaskan { TYPE })"
  },
  "description_436c48d7": {
    "message": "Deskripsi"
  },
  "details_98a31b68": {
    "message": "Detail"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Titik-Titik Diagonal"
  },
  "diamond_b8dfe7ae": {
    "message": "Berlian"
  },
  "diamonds_suit_526abaaf": {
    "message": "Berlian (Suit)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Jenis Dimensi"
  },
  "directionality_26ae9e08": {
    "message": "Direksionalitas"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Langsung Edit LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "Non-aktifkan Pratinjau"
  },
  "discussion_6719c51d": {
    "message": "Diskusi"
  },
  "discussions_a5f96392": {
    "message": "Diskusi"
  },
  "discussions_index_6c36ced": {
    "message": "Indeks Diskusi"
  },
  "disjoint_union_e74351a8": {
    "message": "Disjoint Union"
  },
  "display_options_315aba85": {
    "message": "Opsi Tampilan"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Tampilkan Tautan Teks (Terbuka di tab baru)"
  },
  "div_applied_49ad83fc": {
    "message": "Div diterapkan"
  },
  "div_removed_d13f8e17": {
    "message": "Div dihapus"
  },
  "division_sign_72190870": {
    "message": "Tanda Bagi"
  },
  "document_678cd7bf": {
    "message": "Dokumen"
  },
  "documents_81393201": {
    "message": "Dokumen"
  },
  "done_54e3d4b6": {
    "message": "Selesai"
  },
  "double_dagger_faf78681": {
    "message": "Belati Ganda"
  },
  "down_5831a426": {
    "message": "Turun"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Panah Diagonal Turun dan Kiri"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Panah Diagonal Turun dan Kanan"
  },
  "download_filename_2baae924": {
    "message": "Unduh { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Panas Turun"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Segitiga Mengarah Turun"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Seret file ke sini"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Seret dan jatuhkan, atau klik untuk menjelajahi komputer Anda"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Seret handel. Gunakan panah atas dan bawah untuk mengubah ukuran"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Batas waktu: Tanggal Berganda"
  },
  "due_when_7eed10c6": {
    "message": "Batas Waktu: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Edit teks alternatif untuk instans ikon ini"
  },
  "edit_c5fbea07": {
    "message": "Edit"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Edit Tautan Warna"
  },
  "edit_equation_f5279959": {
    "message": "Edit Persamaan"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Edit Ikon Pembuat Ikon yang Ada"
  },
  "edit_icon_2c6b0e91": {
    "message": "Edit Ikon"
  },
  "edit_link_7f53bebb": {
    "message": "Edit Tautan"
  },
  "editor_status_bar_653f44ee": {
    "message": "Bilah Status Editor"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Elemen yang mulai dengan { start }"
  },
  "embed_828fac4a": {
    "message": "Tanam"
  },
  "embed_code_314f1bd5": {
    "message": "Tanamkan Kode"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Konten tertanam dari Alat Eksternal"
  },
  "embed_image_1080badc": {
    "message": "Tanamkan Gambar"
  },
  "embed_video_a97a64af": {
    "message": "Tanamkan Video"
  },
  "embedded_content_aaeb4d3d": {
    "message": "Konten tertanam"
  },
  "empty_set_91a92df4": {
    "message": "Set Kosong"
  },
  "encircled_dot_8f5e51c": {
    "message": "Titik Dilingkari"
  },
  "encircled_minus_72745096": {
    "message": "Minus Dilingkari"
  },
  "encircled_plus_36d8d104": {
    "message": "Plus Dilingkari"
  },
  "encircled_times_5700096d": {
    "message": "Waktu Dilingkari"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ikon Teknis"
  },
  "english_icon_25bfe845": {
    "message": "Ikon Inggris"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Masukkan nama media"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Masukkan setidaknya 3 karakter untuk mencari"
  },
  "enter_replacement_text_17631bbc": {
    "message": "masukkan teks pengganti"
  },
  "enter_search_text_26cb4459": {
    "message": "mauskkan teks pencarian"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Varian)"
  },
  "equals_sign_c51bdc58": {
    "message": "Tanda Sama Dengan"
  },
  "equation_1c5ac93c": {
    "message": "Persamaan"
  },
  "equation_editor_39fbc3f1": {
    "message": "Editor Persamaan"
  },
  "equilibrium_6ff3040b": {
    "message": "Kesetimbangan"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Kelas Penyetaraan"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Ekuivalen (Identitas)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Yang Ada"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Keluar Dari Layar Penuh"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Perbesar pratinjau secara Default"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Perbesar untuk melihat { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Tautan Eksternal"
  },
  "external_tool_frame_70b32473": {
    "message": "Bingkai alat eksternal"
  },
  "external_tools_6e77821": {
    "message": "Alat Eksternal"
  },
  "extra_large_b6cdf1ff": {
    "message": "Ekstra Besar"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Ekstra Besar ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Ekstra Kecil"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Ikon Ekstrakurikulum"
  },
  "f_function_fe422d65": {
    "message": "F (fungsi)"
  },
  "fail_544e5dde": {
    "message": "GAGAL"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Gagal mengambil konten file"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Gagal mengambil konten dari alat eksternal"
  },
  "file_name_8fd421ff": {
    "message": "Nama file"
  },
  "file_preview_21667a6e": {
    "message": "Pratinjau file"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Pratinjau file untuk { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Kuota penyimpanan file terlampaui"
  },
  "file_url_c12b64be": {
    "message": "URL File"
  },
  "filename_file_icon_602eb5de": {
    "message": "Ikon file { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "Pratinjau gambar { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "Pratinjau teks { filename }"
  },
  "files_c300e900": {
    "message": "File"
  },
  "files_index_af7c662b": {
    "message": "Indeks File"
  },
  "find_8d605019": {
    "message": "Temukan"
  },
  "find_and_replace_6e345933": {
    "message": "Temukan dan Ganti"
  },
  "finish_bc343002": {
    "message": "Selesai"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Perbaiki hierarki heading"
  },
  "flat_music_76d5a5c3": {
    "message": "Datar (Musik)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Bilah alat opsi elemen fokus"
  },
  "folder_tree_fbab0726": {
    "message": "Diagram folder"
  },
  "for_all_b919f972": {
    "message": "Untuk Semua"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Format sebagai daftar"
  },
  "formatting_5b143aa8": {
    "message": "Memformat"
  },
  "forward_slash_3f90f35e": {
    "message": "Garis Miring Maju"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Menemukan konten yang disimpan otomatis"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Menemukan { count, plural,\n     =0 {# hasil}\n    one {# hasil}\n  other {# hasil}\n}"
  },
  "fraction_41bac7af": {
    "message": "Pecahan"
  },
  "fullscreen_873bf53f": {
    "message": "Layar penuh"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Membuat pratinjau..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Gambar berformat GIF/PNG yang lebih besar dari { size } KB saat ini tidak didukung."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Pergi ke bilah menu editor"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Pergi ke bilah menu editor"
  },
  "grades_a61eba0a": {
    "message": "Nilai"
  },
  "graphics_text_bc9568bc": {
    "message": "Teks grafik"
  },
  "greater_than_e98af662": {
    "message": "Lebih Dari"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Lebih Dari Atau Sama Dengan"
  },
  "greek_65c5b3f7": {
    "message": "Yunani"
  },
  "green_15af4778": {
    "message": "Hijau"
  },
  "grey_a55dceff": {
    "message": "Abu-abu"
  },
  "group_documents_8bfd6ae6": {
    "message": "Kelompokkan Dokumen"
  },
  "group_files_4324f3df": {
    "message": "Kelompokkan File"
  },
  "group_files_82e5dcdb": {
    "message": "Kelompokkan file"
  },
  "group_images_98e0ac17": {
    "message": "Kelompokkan Gambar"
  },
  "group_isomorphism_45b1458c": {
    "message": "Kelompokkan Isomorfisme"
  },
  "group_link_63e626b3": {
    "message": "Kelompokkan Tautan"
  },
  "group_links_9493129e": {
    "message": "Kelompokkan Tautan"
  },
  "group_media_2f3d128a": {
    "message": "Kelompokkan Media"
  },
  "group_navigation_99f191a": {
    "message": "Navigasi Grup"
  },
  "h_bar_bb94deae": {
    "message": "H Bar"
  },
  "hat_ea321e35": {
    "message": "Topi"
  },
  "header_column_f27433cb": {
    "message": "Kolom header"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Baris dan kolom header"
  },
  "header_row_f33eb169": {
    "message": "Baris header"
  },
  "heading_2_5b84eed2": {
    "message": "Heading 2"
  },
  "heading_3_2c83de44": {
    "message": "Heading 3"
  },
  "heading_4_b2e74be7": {
    "message": "Heading 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Heading { h } diterapkan"
  },
  "heading_h_removed_745f24a6": {
    "message": "Heading { h } dihapus"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Level heading tidak boleh dilewatkan."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Heading yang mulai dengan { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Heading tidak boleh memuat lebih dari 120 karakter."
  },
  "health_icon_8d292eb5": {
    "message": "Ikon Kesehatan"
  },
  "hearts_suit_e50e04ca": {
    "message": "Hati (Suit)"
  },
  "height_69b03e15": {
    "message": "Tinggi"
  },
  "hexagon_d8468e0d": {
    "message": "Heksagon"
  },
  "hide_description_bfb5502e": {
    "message": "Sembunyikan deskripsi"
  },
  "hide_title_description_caf092ef": {
    "message": "Sembunyikan { title } deskripsi"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Soroti satu elemen untuk mengaktifkan bilah alat opsi elemen itu"
  },
  "home_351838cd": {
    "message": "Beranda"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Bagaimana cara meminta dan mengedit caption?"
  },
  "html_code_editor_fd967a44": {
    "message": "editor kode html"
  },
  "html_editor_fb2ab713": {
    "message": "Editor HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Saya telah mendapat izin untuk menggunakan file ini."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Saya memiliki hak cipta"
  },
  "icon_215a1dc6": {
    "message": "Ikon"
  },
  "icon_8168b2f8": {
    "message": "ikon"
  },
  "icon_color_b86dd6d6": {
    "message": "Ikon Warna"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Ikon Pembuat Ikon"
  },
  "icon_options_7e32746e": {
    "message": "Ikon Opsi"
  },
  "icon_options_tray_2b407977": {
    "message": "Ikon Opsi Tray"
  },
  "icon_preview_1782a1d9": {
    "message": "Ikon Pratinjau"
  },
  "icon_shape_30b61e7": {
    "message": "Ikon Bentuk"
  },
  "icon_size_9353edea": {
    "message": "Ikon Ukuran"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Jika sebelah kiri kosong, teks tautan akan ditampilkan sebagai nama tautan kursus"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Jika Hak Penggunaan dibutuhkan file ini tidak akan diterbitkan hingga di aktifkan pada halaman File."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Jika Anda tidak memilih hak penggunaan sekarang, file ini tidak akan diterbitkan setelah diunggah."
  },
  "image_8ad06": {
    "message": "Gambar"
  },
  "image_c1c98202": {
    "message": "gambar"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Nama file gambar tidak boleh digunakan sebagai atribut alternatif yang menggambarkan konten gambar."
  },
  "image_options_5412d02c": {
    "message": "Opsi Gambar"
  },
  "image_options_tray_90a46006": {
    "message": "Tray Opsi Gambar"
  },
  "image_to_crop_3a34487d": {
    "message": "Gambar untuk dipangkas"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Gambar dengan nama file { file }"
  },
  "images_7ce26570": {
    "message": "Gambar"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Gambar harus menyertakan atribut alternatif yang menjelaskan konten gambar."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Bagian Imajiner (dari Bilangan Kompleks)"
  },
  "in_element_of_19ca2f33": {
    "message": "Pada (Elemen Dari)"
  },
  "increase_indent_6af90f7c": {
    "message": "Tambah Indent"
  },
  "increase_rich_content_area_340b775": {
    "message": "Tambah Area Rich Content"
  },
  "indefinite_integral_6623307e": {
    "message": "Integral Tidak Definit"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } dari { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Inferensi"
  },
  "infinity_7a10f206": {
    "message": "Tak Terhingga"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Bidang input untuk alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Bidang input untuk biru"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Bidang input untuk hijau"
  },
  "input_field_for_red_86a84615": {
    "message": "Bidang input untuk merah"
  },
  "insert_593145ef": {
    "message": "Sisipkan"
  },
  "insert_link_6dc23cae": {
    "message": "Masukkan Tautan"
  },
  "insert_math_equation_57c6e767": {
    "message": "Masukkan Persamaan Matematika"
  },
  "integers_336344e1": {
    "message": "Bilang Bulat"
  },
  "intersection_cd4590e4": {
    "message": "Persimpangan"
  },
  "invalid_description_991e23bb": {
    "message": "Deskripsi tidak valid"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Entri tidak valid."
  },
  "invalid_file_c11ba11": {
    "message": "File Tidak Valid"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Jenis file tidak valid"
  },
  "invalid_url_cbde79f": {
    "message": "URL tidak valid"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Masalah { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Cetak miring diterapkan"
  },
  "italic_removed_17cbab6f": {
    "message": "Cetak miring dihapus"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (Varian)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Pintasan Keyboard"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Navigasikan ke tautan menggunakan tombol Tab di keyboard. Dua tautan berdekatan yang mengarah ke tujuan yang sama dapat berfokus pada pengguna keyboard."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Ikon Seni Bahasa"
  },
  "languages_icon_9d20539": {
    "message": "Ikon Bahasa"
  },
  "large_9c5e80e7": {
    "message": "Besar"
  },
  "large_text_e7ba08cd": {
    "message": "Teks besar"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Besar ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Belajar"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Pelajari selengkapnya tentang tautan berdekatan"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Pelajari selengkapnya tentang kontras warna"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Pelajari selengkapnya tentang mengatur heading halaman"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Pelajari selengkapnya tentang struktur heading halaman yang sesuai"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Pelajari selengkapnya tentang header tabel"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Pelajari selengkapnya tentang menggunakan teks alternatif untuk gambar"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Pelajari selengkapnya tentang menggunakan caption dengan tabel"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Pelajari selengkapnya tentang menggunakan nama file sebagai teks alternatif"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Pelajari selengkapnya tentang menggunakan daftar"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Pelajari selengkapnya tentang menggunakan atribut ruang lingkup dengan tabel"
  },
  "leave_as_is_4facfe55": {
    "message": "Biarkan apa adanya"
  },
  "left_3ea9d375": {
    "message": "Kiri"
  },
  "left_align_43d95491": {
    "message": "Sejajar Kiri"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Kurung Sudut Kiri"
  },
  "left_arrow_4fde1a64": {
    "message": "Panah Kiri"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Panah Kiri Dengan Kait"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Batas Kiri"
  },
  "left_curly_brace_1726fb4": {
    "message": "Kurung Kurawal Kiri"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Panah Harpun Turun Kiri"
  },
  "left_floor_29ac2274": {
    "message": "Lantai Kiri"
  },
  "left_to_right_e9b4fd06": {
    "message": "Kiri ke Kanan"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Panah Harpun Naik Kiri"
  },
  "leftward_arrow_1e4765de": {
    "message": "Panah ke Kiri"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Segitiga Menunjuk ke Arah Kiri"
  },
  "less_than_a26c0641": {
    "message": "Kurang Dari"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Kurang Dari Atau Sama Dengan"
  },
  "library_icon_ae1e54cf": {
    "message": "Ikon Pustaka"
  },
  "light_blue_5374f600": {
    "message": "Biru Mudah"
  },
  "link_7262adec": {
    "message": "Tautan"
  },
  "link_options_a16b758b": {
    "message": "Opsi Tautan"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "jenis tautan: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Tautkan dengan teks yang dimulai dengan { start }"
  },
  "links_14b70841": {
    "message": "Tautan"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Tautan ke situs eksternal."
  },
  "lists_cd1336fc": {
    "message": "Daftar"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Daftar harus diformat sebagai daftar."
  },
  "load_more_35d33c7": {
    "message": "Muat Lebih Banyak"
  },
  "loading_25990131": {
    "message": "Memuat..."
  },
  "loading_bde52856": {
    "message": "Memuat"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "gagal memuat closed caption/subtitle."
  },
  "loading_external_tool_d839042c": {
    "message": "Memuat Alat Eksternal"
  },
  "loading_failed_b3524381": {
    "message": "Gagal memuat..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Gagal memuat."
  },
  "loading_folders_d8b5869e": {
    "message": "Memuat folder"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Memuat placeholder untuk { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Sedang Memuat, mohon menunggu"
  },
  "loading_preview_9f077aa1": {
    "message": "Memuat pratinjau"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Kunci Kecepatan pada 1x"
  },
  "locked_762f138b": {
    "message": "Terkunci"
  },
  "logical_equivalence_76fca396": {
    "message": "Ekuivalen Logis"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Ekuivalen Logis (Singkat)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Ekuivalen Logis (Singkat Dan Tebal)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Ekuivalen Logis (Tebal)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Titik-Titik Horizontal Rendah"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Petakan Ke"
  },
  "math_icon_ad4e9d03": {
    "message": "Ikon Matematika"
  },
  "media_af190855": {
    "message": "Media"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "File media diproses. Silakan coba lagi nanti."
  },
  "media_options_saved_560c4ec8": {
    "message": "Opsi media disimpan."
  },
  "media_title_2112243b": {
    "message": "Judul Media"
  },
  "medium_5a8e9ead": {
    "message": "Medium"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Sedang ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Gabungkan tautan"
  },
  "mic_a7f3d311": {
    "message": "Mic"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikrofon Dinonaktifkan"
  },
  "middle_27dc1d5": {
    "message": "Tengah"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimalkan Pratinjau File"
  },
  "minimize_video_20aa554b": {
    "message": "Minimalkan Video"
  },
  "minus_fd961e2e": {
    "message": "Minus"
  },
  "minus_plus_3461f637": {
    "message": "Minus/Plus"
  },
  "misc_3b692ea7": {
    "message": "Lain-lain"
  },
  "miscellaneous_e9818229": {
    "message": "Lain-Lain"
  },
  "module_90d9fd32": {
    "message": "Modul"
  },
  "modules_c4325335": {
    "message": "Modul"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Memindah gambar untuk memangkas { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Gambar Multi Warna"
  },
  "multiplication_sign_15f95c22": {
    "message": "Tanda Perkalian"
  },
  "music_icon_4db5c972": {
    "message": "Ikon Musik"
  },
  "my_files_2f621040": {
    "message": "File saya"
  },
  "n_th_root_9991a6e4": {
    "message": "Akar pangkat N"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Nama"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Alami (Musik)"
  },
  "natural_numbers_3da07060": {
    "message": "Bilangan Alami"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navigasikan di menu atau bilah alat"
  },
  "navigation_ee9af92d": {
    "message": "Navigasi"
  },
  "nested_greater_than_d852e60d": {
    "message": "Terpasang Lebih Besar Dari"
  },
  "nested_less_than_27d17e58": {
    "message": "Terpasang Kurang Dari"
  },
  "new_quiz_34aacba6": {
    "message": "Kuis Baru"
  },
  "next_40e12421": {
    "message": "Berikutnya"
  },
  "next_findtext_9d69f0fe": {
    "message": "{ findText } Selanjutnya"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Masalah aksesabilitas tidak terdeteksi."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Pengumuman belum dibuat."
  },
  "no_announcements_found_20185afc": {
    "message": "Pengumuman tidak ditemukan."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Tugas belum dibuat."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Tugas tidak ditemukan."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Tidak ada perubahan untuk disimpan"
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Diskusi belum dibuat."
  },
  "no_discussions_found_9284063b": {
    "message": "Diskusi tidak ditemukan."
  },
  "no_e16d9132": {
    "message": "Tidak"
  },
  "no_file_chosen_9a880793": {
    "message": "File tidak dipilih"
  },
  "no_headers_9bc7dc7f": {
    "message": "Tanpa header"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Modul belum dibuat."
  },
  "no_modules_found_2df43a40": {
    "message": "Modul tidak ditemukan."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Halaman belum dibuat."
  },
  "no_pages_found_6799350": {
    "message": "Halaman tidak ditemukan."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Pratinjau tidak tersedia untuk file ini."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Kuis belum dibuat."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Kuis tidak ditemukan."
  },
  "no_results_940393cf": {
    "message": "Tidak ada hasil."
  },
  "no_results_found_58717065": {
    "message": "Hasil tidak ditemukan"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Hasil tidak ditemukan untuk { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Tanpa Video"
  },
  "none_3b5e34d2": {
    "message": "Tidak ada"
  },
  "none_selected_b93d56d2": {
    "message": "Tidak ada yang dipilih"
  },
  "normal_text_7b03da48": {
    "message": "Teks normal"
  },
  "not_equal_6e2980e6": {
    "message": "Tidak Sama Dengan"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Tidak Pada (Bukan Elemen Dari)"
  },
  "not_negation_1418ebb8": {
    "message": "Not (Negasi)"
  },
  "not_subset_dc2b5e84": {
    "message": "Bukan Subset"
  },
  "not_subset_strict_23d282bf": {
    "message": "Bukan Subset (Ketat)"
  },
  "not_superset_5556b913": {
    "message": "Bukan Superset"
  },
  "not_superset_strict_24e06f36": {
    "message": "Bukan Superset (Ketat)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Oktagon"
  },
  "olive_6a3e4d6b": {
    "message": "Zaitun"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Salah satu dari gaya berikut harus ditambahkan untuk menyimpan ikon: Warna Ikon, Ukuran Outline, Teks Ikon, atau Gambar"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Satu atau lebih file gagal direkatkan. Silakan coba mengunggah atau menyeret dan menjatuhkan file."
  },
  "open_circle_e9bd069": {
    "message": "Lingkaran Terbuka"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Buka dialog pintasan keyboard ini"
  },
  "open_title_application_fd624fc5": {
    "message": "Buka aplikasi { title }"
  },
  "operators_a2ef9a93": {
    "message": "Operator"
  },
  "options_3ab0ea65": {
    "message": "Opsi"
  },
  "or_9b70ccaa": {
    "message": "Atau"
  },
  "orange_81386a62": {
    "message": "Oranye"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Daftar Urutan dan Daftar Tanpa Urutan"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Pintasan editor lain dapat ditemukan di"
  },
  "outline_color_3ef2cea7": {
    "message": "Warna Outline"
  },
  "outline_size_a6059a21": {
    "message": "Ukuran Outline"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } bukan protokol yang valid."
  },
  "page_50c4823d": {
    "message": "Halaman"
  },
  "pages_e5414c2c": {
    "message": "Halaman"
  },
  "paragraph_5e5ad8eb": {
    "message": "Paragraf"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Paragraf diterapkan"
  },
  "paragraph_removed_d09320e": {
    "message": "Paragraf dihapus"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Paragraf yang dimulai dengan { start }"
  },
  "parallel_d55d6e38": {
    "message": "Paralel"
  },
  "partial_derivative_4a9159df": {
    "message": "Parsial (Derivatif)"
  },
  "pass_1c19a2b3": {
    "message": "LULUS"
  },
  "paste_5963d1c1": {
    "message": "Rekat"
  },
  "pause_12af3bb4": {
    "message": "Jeda"
  },
  "pentagon_17d82ea3": {
    "message": "Pentagon"
  },
  "people_b4ebb13c": {
    "message": "Orang"
  },
  "percentage_34ab7c2c": {
    "message": "Persentase"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Persentase harus berupa angka"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Persentase harus berupa setidaknya { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Ikon Seni Pertunjukan"
  },
  "perpendicular_7c48ede4": {
    "message": "Tegak Lurus"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (Varian)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Ikon Pendidikan Jasmani"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Varian)"
  },
  "pick_a_color_557abfb0": {
    "message": "Pilih warna"
  },
  "pink_68ad45cb": {
    "message": "Merah Muda"
  },
  "pixels_52ece7d1": {
    "message": "Piksel"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Piksel harus setidaknya { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Putar"
  },
  "play_media_comment_35257210": {
    "message": "Putar komentar media"
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Putar komentar media oleh { name } dari { createdAt }"
  },
  "player_layout_14e09a29": {
    "message": "Tata letak pemutar"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Silakan izinkan Canvas untuk mengakses mikrofon dan webcam Anda."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Silakan pilih file"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Silakan masukkan nama file"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Harap masukkan URL video yang valid dari platform yang didukung."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Silakan pilih file dari jenis yang didukung"
  },
  "plus_d43cd4ec": {
    "message": "Plus"
  },
  "plus_minus_f8be2e83": {
    "message": "Plus/Minus"
  },
  "posted_when_a578f5ab": {
    "message": "Diposting: { when }"
  },
  "power_set_4f26f316": {
    "message": "Power Set"
  },
  "precedes_196b9aef": {
    "message": "Mendahului"
  },
  "precedes_equal_20701e84": {
    "message": "Mendahului Sama Dengan"
  },
  "preformatted_d0670862": {
    "message": "Dipraformat"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Sblm"
  },
  "preview_53003fd2": {
    "message": "Pratinjau"
  },
  "preview_a3f8f854": {
    "message": "PRATINJAU"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Pratinjau dalam overlay"
  },
  "preview_inline_9787330": {
    "message": "Pratinjau inline"
  },
  "previous_bd2ac015": {
    "message": "Sebelumnya"
  },
  "previous_findtext_8dfbfd30": {
    "message": "{ findText } Sebelumnya"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Warna yang dipilih sebelumnya"
  },
  "prime_917ea60e": {
    "message": "Prima"
  },
  "prime_numbers_13464f61": {
    "message": "Bilangan Prima"
  },
  "product_39cf144f": {
    "message": "Produk"
  },
  "proportional_f02800cc": {
    "message": "Proporsional"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protokol harus berupa ftp, http, https, mailto, skype, tel, atau dapat diabaikan"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "diterbitkan"
  },
  "published_when_302d8e23": {
    "message": "Diterbitkan: { when }"
  },
  "pumpkin_904428d5": {
    "message": "LabuPumpkin"
  },
  "purple_7678a9fc": {
    "message": "Ungu"
  },
  "quaternions_877024e0": {
    "message": "Quaternion"
  },
  "quiz_e0dcce8f": {
    "message": "Kuis"
  },
  "quizzes_7e598f57": {
    "message": "Kuis"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Bilangan Rasional"
  },
  "real_numbers_7c99df94": {
    "message": "Bilangan Real"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Bagian Real (dari Bilangan Kompleks)"
  },
  "record_7c9448b": {
    "message": "Rekam"
  },
  "record_upload_media_5fdce166": {
    "message": "Rekam/Unggah Media"
  },
  "recording_98da6bda": {
    "message": "Merekam"
  },
  "red_8258edf3": {
    "message": "Merah"
  },
  "relationships_6602af70": {
    "message": "Hubungan"
  },
  "religion_icon_246e0be1": {
    "message": "Ikon Agama"
  },
  "remove_f47dc62a": {
    "message": "Hapus"
  },
  "remove_filename_3ea029f6": {
    "message": "Hapus { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Hapus gaya heading"
  },
  "remove_link_d1f2f4d0": {
    "message": "Hapus Tautan"
  },
  "replace_all_d3d68b3": {
    "message": "Ganti Semua"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Ganti semua { findText } dengan { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Ganti"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Ganti { findText } dengan { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Ganti dengan"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Mengganti { alertFindText } dengan { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Mengganti semua { alertFindText } dengan { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Atur Ulang"
  },
  "resize_ec83d538": {
    "message": "Ubah Ukuran"
  },
  "restore_auto_save_deccd84b": {
    "message": "Pulihkan simpan otomatis?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Hasil { index } dari { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Kembalikan Turnstile (Tidak Menghasilkan)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Varian)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Editor Rich Text"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Area Rich Text. Tekan { OSKey }+F8 untuk pintasan Rich Content Editor."
  },
  "right_71ffdc4d": {
    "message": "Kanan"
  },
  "right_align_39e7a32a": {
    "message": "Rata Kanan"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Kurung Sudut Kanan"
  },
  "right_arrow_35e0eddf": {
    "message": "Panah Kanan"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Panah Kanan Dengan Kait"
  },
  "right_ceiling_839dc744": {
    "message": "Batas Kanan"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Kurung Kurawal Kanan"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Panah Harpun Turun Kanan"
  },
  "right_floor_5392d5cf": {
    "message": "Lantai Kanan"
  },
  "right_to_left_9cfb092a": {
    "message": "Kanan ke Kiri"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Panah Harpun Naik Kanan"
  },
  "rightward_arrow_32932107": {
    "message": "Panah Arah Kanan"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Segitiga Menunjuk ke Arah Kanan"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Putar gambar -90 derajat"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Putar gambar 90 derajat"
  },
  "rotation_9699c538": {
    "message": "Rotasi"
  },
  "row_fc0944a7": {
    "message": "Baris"
  },
  "row_group_979f5528": {
    "message": "Grup baris"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Sayangnya, editor pretty HTML tidak dapat diakses keyboard. Akses editor raw HTML di sini/"
  },
  "save_11a80ec3": {
    "message": "Simpan"
  },
  "save_copy_ca63944e": {
    "message": "Simpan Salinan"
  },
  "save_media_cb9e786e": {
    "message": "Simpan Media"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Ikon Pembuat Ikon Disimpan"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Pembaca layar tidak dapat menentukan apa yang ditampilkan dalam suatu gambar tanpa teks alternatif, dan nama file sering berupa string angka dan huruf tanpa makna yang tidak menjelaskan konteks atau arti."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Pembaca layar tidak dapat menentukan apa yang ditampilkan pada gambar tanpa teks alternatif, yang menjelaskan konten dan makna dari gambar. Teks alternatif harus sederhana dan padat."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Pembaca layar tidak dapat menentukan apa yang ditampilkan pada gambar tanpa teks alternatif, yang menjelaskan konten dan makna dari gambar."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Pembaca layar tidak dapat menginterpretasikan tabel tanpa struktur yang tepat. Header tabel memberi arah dan ruang lingkup konten."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Pembaca layar tidak dapat menginterpretasikan tabel tanpa struktur yang tepat. Caption tabel menjelaskan konteks dan pemahaman umum dari tabel."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Pembaca layar tidak dapat menginterpretasikan tabel tanpa struktur yang tepat. Header tabel memberi arah dan tinjauan umum dari konten."
  },
  "script_l_42a7b254": {
    "message": "Script L"
  },
  "search_280d00bd": {
    "message": "Cari"
  },
  "select_audio_source_21043cd5": {
    "message": "Pilih sumber audio"
  },
  "select_crop_shape_d441feeb": {
    "message": "Pilih bentuk pangkasan"
  },
  "select_language_7c93a900": {
    "message": "Pilih Bahasa"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Pilih sumber video"
  },
  "selected_274ce24f": {
    "message": "Memilih"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Memilih { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Seleksi"
  },
  "set_header_scope_8c548f40": {
    "message": "Atur ruang lingkup header"
  },
  "set_minus_b46e9b88": {
    "message": "Atur Minus"
  },
  "set_table_header_cfab13a0": {
    "message": "Atur header tabel"
  },
  "sharp_music_ab956814": {
    "message": "Tajam (Musik)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Panah"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O untuk membuka editor pretty html."
  },
  "shortcut_911d6255": {
    "message": "Pintasan"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Tampilkan opsi gambar"
  },
  "show_link_options_545338fd": {
    "message": "Tampilkan opsi tautan"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Tampilkan transkrip bergulir"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Tampilkan Transkrip Bergulir"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Melihat halaman web browser pengguna dengan cepat, mencari heading besar atau ditebalkan. Pengguna pembaca layar bergantung pada header untuk pemahaman kontekstual. Header harus menggunakan struktur yang tepat."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Melihat halaman web browser pengguna dengan cepat, mencari heading besar atau ditebalkan. Pengguna pembaca layar bergantung pada header untuk pemahaman kontekstual. Header harus berada di dalam struktur yang tepat."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (Varian)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Gambar Warna Tunggal"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Warna Gambar Warna Tunggal"
  },
  "size_b30e1077": {
    "message": "Ukuran"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Ukuran file caption lebih besar daripada ukuran file { max } kb maksimum yang diizinkan."
  },
  "small_b070434a": {
    "message": "Kecil"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Kecil ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Lingkaran Padat"
  },
  "something_went_wrong_89195131": {
    "message": "Kesalahan terjadi."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Kesalahan terjadi saat mengakses webcam Anda."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Ada yang salah dan saya tidak tahu apa yang harus diperlihatkan."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Kesalahan terjadi. Periksa sambungan Anda, muat ulang halaman, dan coba lagi."
  },
  "something_went_wrong_d238c551": {
    "message": "Ada sesuatu yang salah"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Terjadi kesalahan saat berbagi layar Anda."
  },
  "sort_by_e75f9e3e": {
    "message": "Sortir Menurut"
  },
  "spades_suit_b37020c2": {
    "message": "Sekop (Suit)"
  },
  "square_511eb3b3": {
    "message": "Bujursangkar"
  },
  "square_cap_9ec88646": {
    "message": "Tutup Kotak"
  },
  "square_cup_b0665113": {
    "message": "Mangkok Kotak"
  },
  "square_root_e8bcbc60": {
    "message": "Akar Kuadrat"
  },
  "square_root_symbol_d0898a53": {
    "message": "Simbol Akar Kuadrat"
  },
  "square_subset_17be67cb": {
    "message": "Subset Kotak"
  },
  "square_subset_strict_7044e84f": {
    "message": "Subset Kotak (Ketat)"
  },
  "square_superset_3be8dae1": {
    "message": "Superset Kotak"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Superset Kotak (Ketat)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "kotaki daftar yang belum diurutkan"
  },
  "star_8d156e09": {
    "message": "Bintang"
  },
  "start_over_f7552aa9": {
    "message": "Mulai Ulang"
  },
  "start_recording_9a65141a": {
    "message": "Mulai Rekaman"
  },
  "steel_blue_14296f08": {
    "message": "Biru Baja"
  },
  "studio_media_options_ee504361": {
    "message": "Opsi Media Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Tray Opsi Media Studio"
  },
  "styles_2aa721ef": {
    "message": "Gaya"
  },
  "submit_a3cc6859": {
    "message": "Serahkan"
  },
  "submitting_b90fac62": {
    "message": "Menyerahkan..."
  },
  "subscript_59744f96": {
    "message": "Subscript"
  },
  "subset_19c1a92f": {
    "message": "Subset"
  },
  "subset_strict_8d8948d6": {
    "message": "Subset (Ketat)"
  },
  "succeeds_9cc31be9": {
    "message": "Menggantikan"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Menggantikan Sama Dengan"
  },
  "sum_b0842d31": {
    "message": "Jumlah"
  },
  "superscript_8cb349a2": {
    "message": "Superscript"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Superscript dan Subscript"
  },
  "superset_c4db8a7a": {
    "message": "Superset"
  },
  "superset_strict_c77dd6d2": {
    "message": "Superset (Ketat)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Jenis file yang didukung: SRT atau WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Beralih ke Editor raw HTML"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Beralih ke Editor raw HTML"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Beralih ke editor html"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Beralih ke editor rich text"
  },
  "syllabus_f191f65b": {
    "message": "Silabus"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Audio Sistem Diizinkan"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Audio Sistem Dinonaktifkan"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/Panah"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Header tabel dimulai dengan { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tabel dimulai dengan { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Header tabel harus menetapkan ruang lingkup."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Tabel harus mencakup caption yang menjelaskan isi tabel."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Tabel harus mencakup setidaknya satu header."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Teal"
  },
  "text_7f4593da": {
    "message": "Teks"
  },
  "text_background_color_16e61c3f": {
    "message": "Warna Latar Belakang Teks"
  },
  "text_color_acf75eb6": {
    "message": "Warna Teks"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Teks sulit dibaca tanpa kontras yang mencukupi antara teks dan latar belakang, terutama untuk mereka yang memiliki kesulitan penglihatan."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Teks yang lebih besar daripada 18pt (atau tebal 14pt) harus menampilkan rasio kontras 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Teks (opsional)"
  },
  "text_position_8df8c162": {
    "message": "Posisi Teks"
  },
  "text_size_887c2f6": {
    "message": "Ukuran Teks"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Teks yang lebih kecil daripada 18pt (atau tebal 14pt) harus menampilkan rasio kontras 4,5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Pratinjau dokumen saat ini sedang diproses. Silakan coba lagi nanti."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Heading pertama pada suatu halaman harus berupa H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Tinggi Area Rich dikurangi."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Tinggi Area Rich ditambah."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Bahan ada di dalam domain publik"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Bahan dilisensikan sesuai dengan Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Bahan tunduk pada pengecualian - mis. penggunaan wajar, hak untuk mengutip, atau undang-undang hak cipta lain yang berlaku"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Editor pretty HTML tidak dapat diakses keyboard. Tekan Shift-O untuk membuka editor raw html."
  },
  "therefore_d860e024": {
    "message": "Karenanya"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (Varian)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Panah Turun Tebal"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Panah Kiri Tebal"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Panah Arah Kiri Tebal"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Panah Kanan Tebal"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Panah Arah Kanan Tebal"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Panah Atas Atas Tebal"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Dokumen ini tidak dapat ditampilkan di dalam Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Persamaan ini tidak bisa disajikan alam Tampilan Dasar."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Gambar ini saat ini tidak tersedia"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Video ini dapat menampilkan iklan YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Walaupun video Anda akan memiliki judul yang benar di browser, kami gagal memperbaruinya di database."
  },
  "thumbnail_e0de666f": {
    "message": "Gambar kecil"
  },
  "timebar_a4d18443": {
    "message": "Bilah Waktu"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Judul tidak boleh kosong"
  },
  "title_ee03d132": {
    "message": "Judul"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "Akan Diposting: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "To Do: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Alihkan { summary } group"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Alihkan tooltip"
  },
  "tools_2fcf772e": {
    "message": "Alat"
  },
  "top_66e0adb6": {
    "message": "Atas"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Panel transkrip tersedia dengan lebar di lebih dari 720px."
  },
  "tray_839df38a": {
    "message": "Tray"
  },
  "triangle_6072304e": {
    "message": "Segitiga"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Turnstile (Hasil)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "tekan Control F9 untuk mengakses opsi gambar. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "tekan Control F9 untuk mengakses opsi tautan. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "tekan Control F9 untuk mengakses opsi tabel. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Tidak dapat menentukan url pemilihan sumber daya"
  },
  "underline_applied_ae01ec97": {
    "message": "Garis bawah diterapkan"
  },
  "underline_removed_3693e17c": {
    "message": "Garis bawah dihapus"
  },
  "union_e6b57a53": {
    "message": "Union"
  },
  "unpublished_dfd8801": {
    "message": "batalkan terbit"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Semua perubahan yang tidak disimpan akan hilang."
  },
  "untitled_16aa4f2b": {
    "message": "Tanpa Nama"
  },
  "untitled_efdc2d7d": {
    "message": "tanpa nama"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Panah Diagonal Atas dan Kiri"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Panah Diagonal Atas dan Kanan"
  },
  "up_c553575d": {
    "message": "Naik"
  },
  "updated_link_a827e441": {
    "message": "Tautan yang diperbarui"
  },
  "upload_document_253f0478": {
    "message": "Unggah Dokumen"
  },
  "upload_file_fd2361b8": {
    "message": "Unggah File"
  },
  "upload_image_6120b609": {
    "message": "Unggah Gambar"
  },
  "upload_media_ce31135a": {
    "message": "Unggah Media"
  },
  "upload_record_media_e4207d72": {
    "message": "Unggah/Rekam Media"
  },
  "uploading_19e8a4e7": {
    "message": "Mengunggah"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "daftar diurutkan berdasarkan abjad huruf besar"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta Huruf Besar"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gamma Huruf Besar"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda Huruf Besar"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega Huruf Besar"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi Huruf Besar"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi Huruf Besar"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi Huruf Besar"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "daftar diurutkan numeral romawi huruf besar"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma Huruf Besar"
  },
  "uppercase_theta_49afc891": {
    "message": "Theta Huruf Besar"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Upsilon Huruf Besar"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi Huruf Besar"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Panah Arah Atas dan Turun"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Panah Arah Atas dan Turun (Tebal)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Panah Atas"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Segitiga Menunjuk ke Arah Atas"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Hak Penggunaan:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Hak Penggunaan (wajib)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Gunakan tombol panah untuk memilih opsi."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Gunakan tombol panah untuk memilih bentuk."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Gunakan tombol panah untuk memilih ukuran."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Gunakan tombol panah untuk memilih posisi teks."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Gunakan tombol panah untuk memilih ukuran teks."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Gunakan tombol panah untuk memilih ukuran outline."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Digunakan oleh pembaca layar untuk menjelaskan konten suatu { TYPE }."
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Digunakan oleh pembaca layar untuk menjelaskan konten suatu gambar"
  },
  "user_documents_c206e61f": {
    "message": "Dokumen Pengguna"
  },
  "user_files_78e21703": {
    "message": "File Pengguna"
  },
  "user_images_b6490852": {
    "message": "Gambar Pengguna"
  },
  "user_media_14fbf656": {
    "message": "Media Pengguna"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektor (Notasi)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Bilah Vertikal (Notasi Set Builder)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Titik-Titik Vertikal"
  },
  "video_options_24ef6e5d": {
    "message": "Opsi Video"
  },
  "video_options_tray_3b9809a5": {
    "message": "Tray Opsi Video"
  },
  "video_player_b371005": {
    "message": "Video Player"
  },
  "video_player_for_9e7d373b": {
    "message": "Video player untuk "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Video player untuk { title }"
  },
  "video_url_889d3263": {
    "message": "URL Video"
  },
  "view_all_e13bf0a6": {
    "message": "Lihat Semua"
  },
  "view_ba339f93": {
    "message": "Lihat"
  },
  "view_description_30446afc": {
    "message": "Lihat deskripsi"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Lihat pintasan keyboard"
  },
  "view_title_description_67940918": {
    "message": "Lihat deskripsi { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Lihat jumlah kata dan karakter"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Pembatasan Pemirsa"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Kami tidak dapat mendeteksi mikrofon yang berfungsi yang tersambung ke perangkat Anda."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Kami tidak dapat mendeteksi webcam yang berfungsi yang tersambung ke perangkat Anda."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Kami tidak dapat mendeteksi webcam atau mikrofon yang tersambung ke perangkat Anda."
  },
  "webcam_disabled_30c66986": {
    "message": "Webcam Dinonaktifkan"
  },
  "webcam_fe91b20f": {
    "message": "Webcam"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Halaman web hanya boleh memiliki H1 tunggal, yang secara otomatis digunakan oleh judul halaman. Heading pertama pada konten Anda harus berupa H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Saat markup digunakan yang secara visual memformat item sebagai daftar tetapi tidak mengindikasikan hubungan daftar, pengguna dapat kesulitan dalam menavigasikan informasi."
  },
  "white_87fa64fd": {
    "message": "Kulit Putih"
  },
  "why_523b3d8c": {
    "message": "Kenapa"
  },
  "width_492fec76": {
    "message": "Lebar"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Lebar dan tinggi harus angka"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Wiki Home"
  },
  "word_count_c77fe3a6": {
    "message": "Jumlah Kata"
  },
  "words_b448b7d5": {
    "message": "Kata"
  },
  "wreath_product_200b38ef": {
    "message": "Produk Wreath"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Ya"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Anda berada di palet warna. Untuk bernavigasi ke atas, kiri, turun, atau kanan di palet, gunakan tombol ''W'', ''A'', ''S'', dan ''D'' secara berurutan"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Anda berada di slider warna. Untuk menavigasikan slider ke kiri atau kanan, gunakan tombol ''A'' dan ''D'' secara berurutan"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Anda berada di slider alfa. Untuk menavigasikan slider ke kiri atau kanan, gunakan tombol ''A'' dan ''D'' secara berurutan"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Anda memiliki perubahan yang belum disimpan di tray Pembuat Ikon. Anda ingin melanjutkan tanpa menyimpan perubahan ini?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Anda mungkin perlu menyesuaikan heading tambahan untuk mempertahankan hiearki halaman."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Anda tidak dapat mengunggah file kosong."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Gambar Anda telah dikompresi untuk Pembuat Ikon. Gambar berukuran kurang dari { size } KB tidak akan dikompresi."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Mikrofon Anda diblokir di pengaturan browser."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Webcam dan mikrofon Anda diblokir di pengaturan browser."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Webcam Anda diblokir di pengaturan browser."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Webcam Anda mungkin sudah digunakan."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL sematan YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Zoom masuk gambar"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Zoom keluar gambar"
  }
};
formatMessage.addLocale({
  id: locale
});